// src/services/apiService.js
import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api/v1",
});

const excludedAuthPaths = ["/login", "/forgot-password"];

API.interceptors.request.use((config) => {
    // Skip adding token if request is in excluded paths
    if (!excludedAuthPaths.some(path => config.url.includes(path))) {
        const token = localStorage.getItem("adminToken");
        if (token) {
            config.headers.Authorization = `${token}`;
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

API.interceptors.response.use(
    (response) => response,
    (error) => {
        // Check if backend says JWT expired
        if (error.response?.data?.message?.toLowerCase().includes("jwt expired")) {
            // 🔥 Clear tokens
            localStorage.removeItem("adminToken");
            localStorage.removeItem("userId");

            // 🔥 Dispatch logout event (to trigger modal in React)
            window.dispatchEvent(new CustomEvent("jwtExpired"));
        }
        return Promise.reject(error);
    }
);

// 📌 Login (does not need token)
export const loginUser = (data) => postData("/login", data);

// 📌 Generic GET
export const getData = async (endpoint, params = {}) => {
    const res = await API.get(endpoint, { params });
    return res.data;
};

// 📌 Generic POST
export const postData = async (endpoint, data, isFormData = false) => {
    const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : { headers: { "Content-Type": "application/json" } };
    const res = await API.post(endpoint, data, config);
    return res.data;
};

// 📌 Generic UPDATE
export const updateData = async (endpoint, data, isFormData = false) => {
    const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
    const res = await API.put(endpoint, data, config);
    return res.data;
};

// 📌 Generic DELETE
export const deleteData = async (endpoint) => {
    const res = await API.delete(endpoint);
    return res.data;
};
